import BaseApiClient from '../BaseApiClient';

import axios from 'axios';
import SearchResponse from '@/interfaces/SearchResponse.interface';
import { ListDataParams, ListDataResponse } from '../types';
axios.defaults.withCredentials = true;
interface MetaData {
  current_page: number;
  pages: number;
  per_page: number;
  total: number;
}

export class ApiGlobalSearch extends BaseApiClient {
  async getFuzzySearch(
    str: string
  ): Promise<{ data: SearchResponse[]; meta: MetaData }> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/global-search?search_term=${str}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  // Version 2025-11-14
  async search(searchTerm: string): Promise<ListDataResponse<SearchResponse>> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/results?filter[search]=${searchTerm}`, {
          headers: {
            Version: '2025-11-14'
          }
        })
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { globalSearchQueryKeys } from './query-keys';
export {
  useGlobalSearchFuzzyQuery,
  useGlobalSearchQuery
} from './use-global-search-queries';
